<template>
  <div id="CmsUploadImage" class="">
    <b-row>
      <b-col>
        <h2 class="pb-3">Upload Image</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert variant="success" :show="imageUrl !== null">Image successfully added! URL: <a :href="imageUrl" target="_blank">{{imageUrl}}</a></b-alert>
        <b-alert variant="danger" :show="error !== null">{{error}}</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form @submit.prevent="onSubmit">
          <b-form-group
            label="File:"
            label-for="file"
            description="Select the image to be uploaded."
          >
            <b-form-file
              id="file"
              v-model="file"
              :state="Boolean(file)"
              name="file"
              ref="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              accept="image/*"
              :disabled="isLoading"
            ></b-form-file>
          </b-form-group>

          <b-button variant="primary" @click="onSubmit" :disabled="isLoading || file === null || file.name === undefined">Upload</b-button>
          <b-button type="reset" variant="danger"  @click="reset" :disabled="isLoading">Reset</b-button>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert show variant="light">
          <p>To see all images that had been uploaded you can check inside the AWS S3 Bucket. To find it:</p>
          <ul>
            <li>Go to this URL to see all S3 Buckets: <a href="https://s3.console.aws.amazon.com/s3/home" target="_blank">https://s3.console.aws.amazon.com/s3/home</a></li>
            <li>Search for the bucket with the name "rebtel.com"</li>
            <li>Open the path: "cms/images/"</li>
          </ul>

          <p>OBS: the image has the following structure name "{YEAR}{MONTH}{DAY}-{HOUR}{MINUTE}{SECOND}-{FILE_NAME}", the date and time are when the image had been uploaded. Ex: 20191004-120000-test.jpg</p>
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { uploadImage } from '@/api/routing-lambda'
export default {
  name: 'CmsUploadImage',
  data () {
    return {
      file: null,
      isLoading: false,
      imageUrl: null,
      error: null
    }
  },
  methods: {
    async onSubmit () {
      try {
        this.isLoading = true
        const response = await uploadImage({ name: this.file.name, type: this.file.type, fileBase64: (await this.getFile(this.file)).target.result })
        this.imageUrl = `https://rebtel.imgix.net/${response.key}`
        this.file = null
      } catch (ex) {
        console.log(ex)
        this.error = ex.toString() || 'Please try again, if the error persists contact web team.'
      } finally {
        this.isLoading = false
      }
    },
    reset () {
      this.file = null
      this.imageUrl = null
    },
    async getFile (file) {
      return new Promise((resolve, reject) => {
        var fr = new FileReader()
        fr.onload = resolve
        fr.readAsDataURL(this.file)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/cms/CmsUploadImage.vue